import { combineReducers } from 'redux';

import { collectionsDuck } from '@eb/redux-destination';
import { DEFAULT_CURRENCY_FORMAT } from '@eb/intl';

import { appReducer } from '../app';
import { contentReducer } from '../content';
import { headerReducer } from '../header';
import { locationReducer } from '../location';
import { organizersReducer } from '../organizers';
import { userReducer } from '../user';
import { searchReducer } from '../search';
import { suggestionsReducer } from '../search';
import { UPDATE_ROOT_CONTEXT } from './rootActionTypes';

const rootReducer = combineReducers({
    app: appReducer,
    content: contentReducer,
    collections: collectionsDuck.reducer,
    location: locationReducer,
    suggestions: suggestionsReducer,
    user: userReducer,
    organizers: organizersReducer,
    search: searchReducer,
    env: (state = {}) => state,
    currencyFormat: (state = DEFAULT_CURRENCY_FORMAT) => state,
    gaSettings: (state = {}) => state,
    shareOptions: (state = {}) => state,
    header: headerReducer,
    headerImageIndex: (state = '') => state,
});

export default function updateableRootReducer(state = {}, action) {
    let newState = state;

    if (action && action.type === UPDATE_ROOT_CONTEXT) {
        newState = action.payload;
    }

    return rootReducer(newState, action);
}
